module.exports = __webpack_public_path__ + "static/media/quickStartTopSectionImage.5697c913.png";